import Icon from '@expo/vector-icons/FontAwesome';
import { Slider } from '@miblanchard/react-native-slider';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { Divider } from 'react-native-elements';
import colors from '@/config/colors';
import store from '@/stores/store';
import { Toggle } from '@/components/ui/therapist/toggle';

export function DailyGoal() {
  const [value, setValue] = useState(
    store.getState().patient.dailyPracticeDurationGoal,
  );
  const [data, setData] = useState([]);

  const [active, setactive] = useState(
    store.getState().patient.activateDailyGoal,
  );
  const styles = StyleSheet.create({
    iconStyle: {
      padding: 10,
      alignSelf: 'center',
    },
  });
  const handleChange = (value) => {
    let newValue = Math.floor(value[0]);
    setValue(newValue);
  };
  useEffect(() => {
    let str = [];
    for (let i = 0; i < value; i += 10) {
      if (i > 90) {
        break;
      }
      str.push(
        <Icon
          style={styles.iconStyle}
          name="star"
          size={25}
          key={`star-${i}`}
          color={active == false ? colors.grey : colors.gold}
        />,
      );
    }
    if (value > 100) {
      str.push(<Text style={{ fontSize: 24 }}>+ {(value - 100) / 10}</Text>);
    }
    setData(str);
  }, [value, active]);

  return (
    <View>
      <View
        style={{
          paddingBottom: 16,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <View style={{ flex: 2 }}>
          <Text style={{ fontSize: 18 }}>Tagesziel aktivieren</Text>
        </View>
        <Toggle
          value={active}
          onToggle={(newValue) => {
            setactive(newValue);
            store.getState().patient.activateDailyGoal = newValue;
          }}
        />
      </View>
      <Divider color={colors.grey} width={2} />
      <View style={active ? {} : { opacity: 0.3, pointerEvents: 'none' }}>
        <View>
          <Text
            style={{
              paddingTop: 16,
              fontSize: 14,
              maxWidth: 800,
            }}
          >
            Legen Sie hier fest, wie lange das Eigentraining täglich verwendet
            werden sollte. Nach Aphasie-Leitlinie empfehlen wir ein Tagesziel
            von mindestens 40 Minuten.
          </Text>
        </View>
        <View
          style={{
            paddingVertical: 16,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <View style={{ flex: 2, minWidth: 120 }}>
            <Text style={{ fontSize: 16 }}>Übungsdauer</Text>
          </View>
          <View style={{ flex: 10 }}>
            <Slider
              value={value}
              onValueChange={(value) => {
                handleChange(value);
              }}
              maximumTrackTintColor={colors.grey}
              maximumValue={240}
              minimumTrackTintColor={
                active == false ? colors.grey : colors.primary
              }
              thumbTintColor={active == false ? colors.grey : colors.primary}
              minimumValue={10}
              step={10}
              onSlidingComplete={(value) =>
                // eslint-disable-next-line indent
                (store.getState().patient.dailyPracticeDurationGoal =
                  Math.floor(value))
              }
              trackClickable={true}
            />
          </View>
          <View style={{ flex: 3, alignItems: 'center', minWidht: 160 }}>
            <Text style={{ fontSize: 14 }}>{value}&nbsp;Minuten</Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            paddingBottom: 16,
          }}
        >
          {data}
        </View>
      </View>
    </View>
  );
}
